"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rocPayloadToFormDataHandler = rocPayloadToFormDataHandler;
const domain_1 = require("@home-health-notify/domain");
const getServiceFrequency = (data, service) => {
    const serviceKey = `${service.toLowerCase()}Frequency`;
    const frequency = data.form[serviceKey];
    if (!frequency)
        return null;
    const newServiceKey = `${service} Frequency`;
    return {
        [newServiceKey]: frequency,
    };
};
const getServicesWithFrequency = (data, template) => {
    const servicesSchema = template.schema.properties.services;
    const roles = Object.keys(domain_1.CLINICIAN_ROLES).filter(role => role !== domain_1.CLINICIAN_ROLES.CR);
    let services = {};
    roles.forEach(role => {
        var _a, _b;
        const options = ((_a = servicesSchema.properties[role]) === null || _a === void 0 ? void 0 : _a.oneOf) || [];
        services[role] = (_b = options.find((option) => option.const == data.form[role])) === null || _b === void 0 ? void 0 : _b.title;
        const serviceFrequency = getServiceFrequency(data, role);
        if (serviceFrequency) {
            services = Object.assign(Object.assign({}, services), serviceFrequency);
        }
    });
    return services;
};
function rocPayloadToFormDataHandler(data, template) {
    const services = getServicesWithFrequency(data, template);
    return {
        rocDate: {
            visitDate: data.form.ROCDate,
            visitStartTime: data.form.visitTimeIn,
            visitEndTime: data.form.visitTimeOut,
        },
        doctorName: data.form.physicianName || "N/A",
        phoneNumberWithCountryCode: {
            countryCode: data.form.countryCode || "",
            phoneNumber: +(data.form.phoneNumber || 0),
        },
        contactPerson: data.form.contactPersonAtDoctorOffice || "N/A",
        nextDoctorVisit: data.form.nextDoctorVisitDate,
        clinicianAppointment: {
            visitDate: data.form.nextVisitDate,
            visitStartTime: data.form.nextVisitStartTime,
            visitEndTime: data.form.nextVisitEndTime,
        },
        services,
        notes: data.form.notes || "",
    };
}
